/**
 * 角色权限管理模块 - 模拟数据
 */

import type {
  Role,
  Permission,
  RolePermission,
  PermissionMatrixData,
} from './types';

// ==================== 角色数据 ====================

export const mockRoles: Role[] = [
  {
    id: 1,
    name: '超级管理员',
    code: 'ROLE_SUPER_ADMIN',
    description: '系统最高权限，拥有所有操作权限',
    type: 'system',
    userCount: 2,
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 2,
    name: '系统管理员',
    code: 'ROLE_SYSTEM_ADMIN',
    description: '系统管理权限，可管理用户、角色等',
    type: 'system',
    userCount: 5,
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 3,
    name: '财务专员',
    code: 'ROLE_FINANCE_STAFF',
    description: '财务相关功能权限',
    type: 'custom',
    userCount: 8,
    status: 'active',
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-02-15T00:00:00Z',
  },
  {
    id: 4,
    name: '仓库管理员',
    code: 'ROLE_WAREHOUSE_ADMIN',
    description: '仓库管理权限',
    type: 'custom',
    userCount: 12,
    status: 'active',
    createdAt: '2024-02-10T00:00:00Z',
    updatedAt: '2024-03-01T00:00:00Z',
  },
  {
    id: 5,
    name: '采购专员',
    code: 'ROLE_PURCHASE_STAFF',
    description: '采购相关功能权限',
    type: 'custom',
    userCount: 6,
    status: 'active',
    createdAt: '2024-03-01T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
  },
  {
    id: 6,
    name: '销售专员',
    code: 'ROLE_SALES_STAFF',
    description: '销售订单处理权限',
    type: 'custom',
    userCount: 15,
    status: 'active',
    createdAt: '2024-03-10T00:00:00Z',
    updatedAt: '2024-04-01T00:00:00Z',
  },
  {
    id: 7,
    name: '客服专员',
    code: 'ROLE_SERVICE_STAFF',
    description: '客户服务权限',
    type: 'custom',
    userCount: 10,
    status: 'active',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2024-04-15T00:00:00Z',
  },
  {
    id: 8,
    name: '数据分析师',
    code: 'ROLE_ANALYST',
    description: '数据查看和分析权限',
    type: 'custom',
    userCount: 3,
    status: 'active',
    createdAt: '2024-05-01T00:00:00Z',
    updatedAt: '2024-05-15T00:00:00Z',
  },
  {
    id: 9,
    name: '访客',
    code: 'ROLE_GUEST',
    description: '只读权限',
    type: 'custom',
    userCount: 0,
    status: 'disabled',
    createdAt: '2024-06-01T00:00:00Z',
    updatedAt: '2024-06-01T00:00:00Z',
  },
  {
    id: 10,
    name: '测试角色',
    code: 'ROLE_TEST',
    description: '测试用角色',
    type: 'custom',
    userCount: 1,
    status: 'disabled',
    createdAt: '2024-07-01T00:00:00Z',
    updatedAt: '2024-07-01T00:00:00Z',
  },
];

// ==================== 权限树数据 ====================

export const mockPermissions: Permission[] = [
  {
    id: 'menu-1',
    parentId: null,
    name: '系统管理',
    code: 'system',
    type: 'menu',
    path: '/system',
    icon: 'SettingOutlined',
    sort: 1,
    children: [
      {
        id: 'menu-1-1',
        parentId: 'menu-1',
        name: '用户管理',
        code: 'system:user',
        type: 'menu',
        path: '/system/user',
        icon: 'UserOutlined',
        sort: 1,
        children: [
          {
            id: 'action-1-1-1',
            parentId: 'menu-1-1',
            name: '查看用户',
            code: 'system:user:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-1-1-2',
            parentId: 'menu-1-1',
            name: '新增用户',
            code: 'system:user:add',
            type: 'action',
            sort: 2,
          },
          {
            id: 'action-1-1-3',
            parentId: 'menu-1-1',
            name: '编辑用户',
            code: 'system:user:edit',
            type: 'action',
            sort: 3,
          },
          {
            id: 'action-1-1-4',
            parentId: 'menu-1-1',
            name: '删除用户',
            code: 'system:user:delete',
            type: 'action',
            sort: 4,
          },
          {
            id: 'action-1-1-5',
            parentId: 'menu-1-1',
            name: '导出用户',
            code: 'system:user:export',
            type: 'action',
            sort: 5,
          },
        ],
      },
      {
        id: 'menu-1-2',
        parentId: 'menu-1',
        name: '角色管理',
        code: 'system:role',
        type: 'menu',
        path: '/system/role',
        icon: 'TeamOutlined',
        sort: 2,
        children: [
          {
            id: 'action-1-2-1',
            parentId: 'menu-1-2',
            name: '查看角色',
            code: 'system:role:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-1-2-2',
            parentId: 'menu-1-2',
            name: '新增角色',
            code: 'system:role:add',
            type: 'action',
            sort: 2,
          },
          {
            id: 'action-1-2-3',
            parentId: 'menu-1-2',
            name: '编辑角色',
            code: 'system:role:edit',
            type: 'action',
            sort: 3,
          },
          {
            id: 'action-1-2-4',
            parentId: 'menu-1-2',
            name: '删除角色',
            code: 'system:role:delete',
            type: 'action',
            sort: 4,
          },
          {
            id: 'action-1-2-5',
            parentId: 'menu-1-2',
            name: '配置权限',
            code: 'system:role:permission',
            type: 'action',
            sort: 5,
          },
        ],
      },
      {
        id: 'menu-1-3',
        parentId: 'menu-1',
        name: '菜单管理',
        code: 'system:menu',
        type: 'menu',
        path: '/system/menu',
        icon: 'MenuOutlined',
        sort: 3,
        children: [
          {
            id: 'action-1-3-1',
            parentId: 'menu-1-3',
            name: '查看菜单',
            code: 'system:menu:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-1-3-2',
            parentId: 'menu-1-3',
            name: '新增菜单',
            code: 'system:menu:add',
            type: 'action',
            sort: 2,
          },
          {
            id: 'action-1-3-3',
            parentId: 'menu-1-3',
            name: '编辑菜单',
            code: 'system:menu:edit',
            type: 'action',
            sort: 3,
          },
          {
            id: 'action-1-3-4',
            parentId: 'menu-1-3',
            name: '删除菜单',
            code: 'system:menu:delete',
            type: 'action',
            sort: 4,
          },
        ],
      },
    ],
  },
  {
    id: 'menu-2',
    parentId: null,
    name: '财务管理',
    code: 'finance',
    type: 'menu',
    path: '/finance',
    icon: 'AccountBookOutlined',
    sort: 2,
    children: [
      {
        id: 'menu-2-1',
        parentId: 'menu-2',
        name: '账户管理',
        code: 'finance:account',
        type: 'menu',
        path: '/finance/account',
        sort: 1,
        children: [
          {
            id: 'action-2-1-1',
            parentId: 'menu-2-1',
            name: '查看账户',
            code: 'finance:account:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-2-1-2',
            parentId: 'menu-2-1',
            name: '新增账户',
            code: 'finance:account:add',
            type: 'action',
            sort: 2,
          },
          {
            id: 'action-2-1-3',
            parentId: 'menu-2-1',
            name: '编辑账户',
            code: 'finance:account:edit',
            type: 'action',
            sort: 3,
          },
        ],
      },
      {
        id: 'menu-2-2',
        parentId: 'menu-2',
        name: '账单管理',
        code: 'finance:bill',
        type: 'menu',
        path: '/finance/bill',
        sort: 2,
        children: [
          {
            id: 'action-2-2-1',
            parentId: 'menu-2-2',
            name: '查看账单',
            code: 'finance:bill:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-2-2-2',
            parentId: 'menu-2-2',
            name: '导出账单',
            code: 'finance:bill:export',
            type: 'action',
            sort: 2,
          },
          {
            id: 'action-2-2-3',
            parentId: 'menu-2-2',
            name: '审核账单',
            code: 'finance:bill:audit',
            type: 'action',
            sort: 3,
          },
        ],
      },
    ],
  },
  {
    id: 'menu-3',
    parentId: null,
    name: '仓库管理',
    code: 'warehouse',
    type: 'menu',
    path: '/warehouse',
    icon: 'ShopOutlined',
    sort: 3,
    children: [
      {
        id: 'menu-3-1',
        parentId: 'menu-3',
        name: '库存管理',
        code: 'warehouse:stock',
        type: 'menu',
        path: '/warehouse/stock',
        sort: 1,
        children: [
          {
            id: 'action-3-1-1',
            parentId: 'menu-3-1',
            name: '查看库存',
            code: 'warehouse:stock:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-3-1-2',
            parentId: 'menu-3-1',
            name: '调整库存',
            code: 'warehouse:stock:adjust',
            type: 'action',
            sort: 2,
          },
        ],
      },
      {
        id: 'menu-3-2',
        parentId: 'menu-3',
        name: '出入库',
        code: 'warehouse:inout',
        type: 'menu',
        path: '/warehouse/inout',
        sort: 2,
        children: [
          {
            id: 'action-3-2-1',
            parentId: 'menu-3-2',
            name: '入库操作',
            code: 'warehouse:inout:in',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-3-2-2',
            parentId: 'menu-3-2',
            name: '出库操作',
            code: 'warehouse:inout:out',
            type: 'action',
            sort: 2,
          },
        ],
      },
    ],
  },
  {
    id: 'menu-4',
    parentId: null,
    name: '订单管理',
    code: 'order',
    type: 'menu',
    path: '/order',
    icon: 'ShoppingOutlined',
    sort: 4,
    children: [
      {
        id: 'menu-4-1',
        parentId: 'menu-4',
        name: '销售订单',
        code: 'order:sales',
        type: 'menu',
        path: '/order/sales',
        sort: 1,
        children: [
          {
            id: 'action-4-1-1',
            parentId: 'menu-4-1',
            name: '查看订单',
            code: 'order:sales:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-4-1-2',
            parentId: 'menu-4-1',
            name: '创建订单',
            code: 'order:sales:add',
            type: 'action',
            sort: 2,
          },
          {
            id: 'action-4-1-3',
            parentId: 'menu-4-1',
            name: '编辑订单',
            code: 'order:sales:edit',
            type: 'action',
            sort: 3,
          },
          {
            id: 'action-4-1-4',
            parentId: 'menu-4-1',
            name: '取消订单',
            code: 'order:sales:cancel',
            type: 'action',
            sort: 4,
          },
        ],
      },
      {
        id: 'menu-4-2',
        parentId: 'menu-4',
        name: '采购订单',
        code: 'order:purchase',
        type: 'menu',
        path: '/order/purchase',
        sort: 2,
        children: [
          {
            id: 'action-4-2-1',
            parentId: 'menu-4-2',
            name: '查看订单',
            code: 'order:purchase:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-4-2-2',
            parentId: 'menu-4-2',
            name: '创建订单',
            code: 'order:purchase:add',
            type: 'action',
            sort: 2,
          },
        ],
      },
    ],
  },
  {
    id: 'menu-5',
    parentId: null,
    name: '报表分析',
    code: 'report',
    type: 'menu',
    path: '/report',
    icon: 'BarChartOutlined',
    sort: 5,
    children: [
      {
        id: 'menu-5-1',
        parentId: 'menu-5',
        name: '销售报表',
        code: 'report:sales',
        type: 'menu',
        path: '/report/sales',
        sort: 1,
        children: [
          {
            id: 'action-5-1-1',
            parentId: 'menu-5-1',
            name: '查看报表',
            code: 'report:sales:view',
            type: 'action',
            sort: 1,
          },
          {
            id: 'action-5-1-2',
            parentId: 'menu-5-1',
            name: '导出报表',
            code: 'report:sales:export',
            type: 'action',
            sort: 2,
          },
        ],
      },
    ],
  },
];

// ==================== 角色权限关联数据 ====================

export const mockRolePermissions: Record<number, RolePermission> = {
  // 超级管理员：拥有所有权限
  1: {
    roleId: 1,
    permissionIds: getAllPermissionIds(mockPermissions),
    checkedKeys: getAllPermissionIds(mockPermissions),
    halfCheckedKeys: [],
  },
  // 系统管理员：系统管理模块
  2: {
    roleId: 2,
    permissionIds: [
      'menu-1',
      'menu-1-1',
      'action-1-1-1',
      'action-1-1-2',
      'action-1-1-3',
      'action-1-1-5',
      'menu-1-2',
      'action-1-2-1',
      'action-1-2-2',
      'action-1-2-3',
      'action-1-2-5',
      'menu-1-3',
      'action-1-3-1',
      'action-1-3-2',
      'action-1-3-3',
    ],
    checkedKeys: [
      'menu-1',
      'menu-1-1',
      'action-1-1-1',
      'action-1-1-2',
      'action-1-1-3',
      'action-1-1-5',
      'menu-1-2',
      'action-1-2-1',
      'action-1-2-2',
      'action-1-2-3',
      'action-1-2-5',
      'menu-1-3',
      'action-1-3-1',
      'action-1-3-2',
      'action-1-3-3',
    ],
    halfCheckedKeys: [],
  },
  // 财务专员：财务模块
  3: {
    roleId: 3,
    permissionIds: [
      'menu-2',
      'menu-2-1',
      'action-2-1-1',
      'action-2-1-2',
      'action-2-1-3',
      'menu-2-2',
      'action-2-2-1',
      'action-2-2-2',
      'action-2-2-3',
    ],
    checkedKeys: [
      'menu-2',
      'menu-2-1',
      'action-2-1-1',
      'action-2-1-2',
      'action-2-1-3',
      'menu-2-2',
      'action-2-2-1',
      'action-2-2-2',
      'action-2-2-3',
    ],
    halfCheckedKeys: [],
  },
  // 仓库管理员：仓库模块
  4: {
    roleId: 4,
    permissionIds: [
      'menu-3',
      'menu-3-1',
      'action-3-1-1',
      'action-3-1-2',
      'menu-3-2',
      'action-3-2-1',
      'action-3-2-2',
    ],
    checkedKeys: [
      'menu-3',
      'menu-3-1',
      'action-3-1-1',
      'action-3-1-2',
      'menu-3-2',
      'action-3-2-1',
      'action-3-2-2',
    ],
    halfCheckedKeys: [],
  },
  // 采购专员：采购订单
  5: {
    roleId: 5,
    permissionIds: [
      'menu-4',
      'menu-4-2',
      'action-4-2-1',
      'action-4-2-2',
    ],
    checkedKeys: [
      'menu-4',
      'menu-4-2',
      'action-4-2-1',
      'action-4-2-2',
    ],
    halfCheckedKeys: [],
  },
  // 销售专员：销售订单
  6: {
    roleId: 6,
    permissionIds: [
      'menu-4',
      'menu-4-1',
      'action-4-1-1',
      'action-4-1-2',
      'action-4-1-3',
    ],
    checkedKeys: [
      'menu-4',
      'menu-4-1',
      'action-4-1-1',
      'action-4-1-2',
      'action-4-1-3',
    ],
    halfCheckedKeys: [],
  },
  // 客服专员：只读权限
  7: {
    roleId: 7,
    permissionIds: [
      'menu-4',
      'menu-4-1',
      'action-4-1-1',
    ],
    checkedKeys: [
      'menu-4',
      'menu-4-1',
      'action-4-1-1',
    ],
    halfCheckedKeys: [],
  },
  // 数据分析师：报表查看
  8: {
    roleId: 8,
    permissionIds: [
      'menu-5',
      'menu-5-1',
      'action-5-1-1',
      'action-5-1-2',
    ],
    checkedKeys: [
      'menu-5',
      'menu-5-1',
      'action-5-1-1',
      'action-5-1-2',
    ],
    halfCheckedKeys: [],
  },
};

// ==================== 辅助函数 ====================

function getAllPermissionIds(permissions: Permission[]): (number | string)[] {
  const ids: (number | string)[] = [];

  function collect(nodes: Permission[]) {
    nodes.forEach((node) => {
      ids.push(node.id);
      if (node.children && node.children.length > 0) {
        collect(node.children);
      }
    });
  }

  collect(permissions);
  return ids;
}

// ==================== 生成器函数 ====================

/**
 * 生成随机角色
 */
export function generateMockRoles(count: number): Role[] {
  const roles: Role[] = [];
  const types: ('system' | 'custom')[] = ['system', 'custom'];
  const statuses: ('active' | 'disabled')[] = ['active', 'disabled'];

  for (let i = 0; i < count; i++) {
    roles.push({
      id: 100 + i,
      name: `角色${i + 1}`,
      code: `ROLE_GENERATED_${i + 1}`,
      description: `这是生成的第${i + 1}个角色`,
      type: types[Math.floor(Math.random() * types.length)],
      userCount: Math.floor(Math.random() * 20),
      status: statuses[Math.floor(Math.random() * statuses.length)],
      createdAt: new Date(
        2024,
        Math.floor(Math.random() * 12),
        Math.floor(Math.random() * 28) + 1
      ).toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }

  return roles;
}

/**
 * 生成权限矩阵数据
 */
export function generateMockPermissionMatrix(): PermissionMatrixData {
  const matrix: Record<number, (number | string)[]> = {};

  mockRoles.forEach((role) => {
    if (mockRolePermissions[role.id]) {
      matrix[role.id] = mockRolePermissions[role.id].permissionIds;
    } else {
      matrix[role.id] = [];
    }
  });

  return {
    roles: mockRoles,
    permissions: mockPermissions,
    matrix,
  };
}

/**
 * 获取角色权限
 */
export function getMockRolePermission(roleId: number): RolePermission {
  return (
    mockRolePermissions[roleId] || {
      roleId,
      permissionIds: [],
      checkedKeys: [],
      halfCheckedKeys: [],
    }
  );
}
